import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import * as React from 'react';
import { useRouter } from 'next/router';
import { styled } from '@mui/material/styles';
import { exactProp } from '@mui/utils';
import GlobalStyles from '@mui/material/GlobalStyles';
import { AdManager, AD_MARGIN_TOP, AD_HEIGHT, AD_HEIGHT_MOBILE, AD_MARGIN_BOTTOM } from '@mui/docs/Ad';
import Head from 'docs/src/modules/components/Head';
import AppFrame from 'docs/src/modules/components/AppFrame';
import AppContainer from 'docs/src/modules/components/AppContainer';
import AppTableOfContents from 'docs/src/modules/components/AppTableOfContents';
import AppLayoutDocsFooter from 'docs/src/modules/components/AppLayoutDocsFooter';
import BackToTop from 'docs/src/modules/components/BackToTop';
import getProductInfoFromUrl from 'docs/src/modules/utils/getProductInfoFromUrl';
import { convertProductIdToName } from 'docs/src/modules/components/AppSearch';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TOC_WIDTH = 242;
var Main = styled('main', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'disableToc';
  }
})(function (_ref) {
  var theme = _ref.theme;
  return {
    minHeight: '100vh',
    display: 'grid',
    width: '100%',
    '& .markdown-body .comment-link': {
      display: 'flex'
    },
    variants: [{
      props: function props(_ref2) {
        var disableToc = _ref2.disableToc;
        return disableToc;
      },
      style: _defineProperty({}, theme.breakpoints.up('md'), {
        marginRight: TOC_WIDTH / 2
      })
    }, {
      props: function props(_ref3) {
        var disableToc = _ref3.disableToc;
        return !disableToc;
      },
      style: _defineProperty({}, theme.breakpoints.up('md'), {
        gridTemplateColumns: "1fr ".concat(TOC_WIDTH, "px")
      })
    }]
  };
});
var StyledAppContainer = styled(AppContainer, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'disableAd' && prop !== 'hasTabs' && prop !== 'disableToc';
  }
})(function (_ref4) {
  var theme = _ref4.theme;
  return _defineProperty(_defineProperty({
    position: 'relative',
    // By default, a grid item cannot be smaller than the size of its content.
    // https://stackoverflow.com/questions/43311943/prevent-content-from-expanding-grid-items
    minWidth: 0
  }, theme.breakpoints.up('lg'), {
    paddingLeft: '60px',
    paddingRight: '60px'
  }), "variants", [{
    props: function props(_ref5) {
      var disableToc = _ref5.disableToc;
      return disableToc;
    },
    style: {
      // 105ch ≈ 930px
      maxWidth: "calc(105ch + ".concat(TOC_WIDTH / 2, "px)")
    }
  }, {
    props: function props(_ref6) {
      var disableToc = _ref6.disableToc;
      return !disableToc;
    },
    style: {
      // We're mostly hosting text content so max-width by px does not make sense considering font-size is system-adjustable.
      fontFamily: 'Arial',
      // 105ch ≈ 930px
      maxWidth: '105ch'
    }
  }, {
    props: function props(_ref7) {
      var disableAd = _ref7.disableAd,
        hasTabs = _ref7.hasTabs;
      return !disableAd && hasTabs;
    },
    style: {
      '&& .component-tabs .MuiTabs-root': _defineProperty({
        // 40px matches MarkdownElement h2 margin-top.
        marginBottom: "calc(".concat(theme.spacing(AD_MARGIN_TOP), " + ").concat(AD_HEIGHT_MOBILE, "px + 40px)")
      }, theme.breakpoints.up('sm'), {
        marginBottom: "calc(".concat(theme.spacing(AD_MARGIN_TOP), " + ").concat(AD_HEIGHT, "px + 40px)")
      }),
      '&& .component-tabs.ad .MuiTabs-root': {
        marginBottom: 0
      }
    }
  }, {
    props: function props(_ref8) {
      var disableAd = _ref8.disableAd,
        hasTabs = _ref8.hasTabs;
      return !disableAd && !hasTabs;
    },
    style: {
      '&& .description': _defineProperty({
        marginBottom: theme.spacing(AD_MARGIN_BOTTOM),
        paddingBottom: "calc(".concat(theme.spacing(AD_MARGIN_TOP), " + ").concat(AD_HEIGHT_MOBILE, "px)")
      }, theme.breakpoints.up('sm'), {
        paddingBottom: "calc(".concat(theme.spacing(AD_MARGIN_TOP), " + ").concat(AD_HEIGHT, "px)")
      }),
      '&& .description.ad': {
        paddingBottom: 0,
        marginBottom: 0
      }
    }
  }]);
});
export default function AppLayoutDocs(props) {
  var _cardOptions$title, _cardOptions$descript;
  var router = useRouter();
  var BannerComponent = props.BannerComponent,
    cardOptions = props.cardOptions,
    children = props.children,
    description = props.description,
    _props$disableAd = props.disableAd,
    disableAd = _props$disableAd === void 0 ? false : _props$disableAd,
    _props$disableLayout = props.disableLayout,
    disableLayout = _props$disableLayout === void 0 ? false : _props$disableLayout,
    _props$disableToc = props.disableToc,
    disableToc = _props$disableToc === void 0 ? false : _props$disableToc,
    _props$hasTabs = props.hasTabs,
    hasTabs = _props$hasTabs === void 0 ? false : _props$hasTabs,
    location = props.location,
    title = props.title,
    toc = props.toc;
  if (description === undefined) {
    throw new Error('Missing description in the page');
  }
  var productName = convertProductIdToName(getProductInfoFromUrl(router.asPath));
  if (!productName) {
    console.error('productName mapping missing for', router.asPath);
  }
  var Layout = disableLayout ? React.Fragment : AppFrame;
  var layoutProps = disableLayout ? {} : {
    BannerComponent: BannerComponent
  };
  var card = "/edge-functions/og-image?product=".concat(productName, "&title=").concat((_cardOptions$title = cardOptions == null ? void 0 : cardOptions.title) != null ? _cardOptions$title : title, "&description=").concat((_cardOptions$descript = cardOptions == null ? void 0 : cardOptions.description) != null ? _cardOptions$descript : description);
  return /*#__PURE__*/_jsxs(Layout, _extends({}, layoutProps, {
    children: [/*#__PURE__*/_jsx(GlobalStyles, {
      styles: {
        ':root': {
          '--MuiDocs-navDrawer-width': '300px'
        }
      }
    }), /*#__PURE__*/_jsxs(AdManager, _extends({}, hasTabs && {
      classSelector: '.component-tabs'
    }, {
      children: [/*#__PURE__*/_jsx(Head, {
        title: "".concat(title).concat(productName ? " - ".concat(productName) : ''),
        description: description,
        card: card
      }), /*#__PURE__*/_jsxs(Main, {
        disableToc: disableToc,
        children: [/*#__PURE__*/_jsxs(StyledAppContainer, {
          disableAd: disableAd,
          hasTabs: hasTabs,
          disableToc: disableToc,
          children: [children, /*#__PURE__*/_jsx(AppLayoutDocsFooter, {
            tableOfContents: toc,
            location: location
          })]
        }), disableToc ? null : /*#__PURE__*/_jsx(AppTableOfContents, {
          toc: toc
        }), /*#__PURE__*/_jsx(BackToTop, {})]
      })]
    }))]
  }));
}
false ? void 0 : void 0;
if (false) {
  false ? void 0 : void 0;
}